import { useRef, useState } from "react";
import { createPortal } from "react-dom";

const cache = new Map();

// Anteprima ingrandita al passaggio del mouse. loadUrl: () => Promise<string|null>
export const HoverPreview = ({ enabled, loadUrl, cacheKey, title, children, className = "" }) => {
  const [pos, setPos] = useState(null);
  const [url, setUrl] = useState(null);
  const timer = useRef(null);
  if (!enabled) return <div className={className}>{children}</div>;
  const enter = (e) => {
    const mx = e.clientX, my = e.clientY;
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      let u = cache.get(cacheKey);
      if (u === undefined) { u = await loadUrl().catch(() => null); cache.set(cacheKey, u); }
      if (!u) return;
      const w = 360, h = 420;
      const left = mx + 24 + w < window.innerWidth ? mx + 24 : Math.max(8, mx - w - 24);
      const top = Math.min(Math.max(8, my - 40), window.innerHeight - h - 8);
      setUrl(u); setPos({ left, top });
    }, 350);
  };
  const leave = () => { clearTimeout(timer.current); setPos(null); };
  return (
    <div className={className} onMouseEnter={enter} onMouseLeave={leave}>
      {children}
      {pos && url && createPortal(
        <div className="fixed z-[9999] pointer-events-none rounded-lg border border-slate-300 bg-white shadow-2xl p-2 w-[360px]" style={{ left: pos.left, top: pos.top }} data-testid="hover-preview">
          <img src={url} alt={title} className="max-h-[380px] w-full object-contain" />
          <div className="mt-1 text-xs text-slate-700 truncate">{title}</div>
        </div>, document.body)}
    </div>
  );
};

export const PREVIEW_KEY = "pgp_hover_preview";
export const usePreviewPref = (key = PREVIEW_KEY) => {
  const [on, setOn] = useState(() => localStorage.getItem(key) !== "0");
  const set = (v) => { setOn(v); localStorage.setItem(key, v ? "1" : "0"); };
  return [on, set];
};

export const PreviewToggle = ({ on, onChange, testId = "hover-preview-toggle", light = false }) => (
  <label className={`inline-flex items-center gap-1.5 text-xs cursor-pointer ${light ? "text-slate-600" : "text-slate-400"}`}>
    <input type="checkbox" checked={on} onChange={(e) => onChange(e.target.checked)} data-testid={testId} className="h-3.5 w-3.5 accent-amber-500" />
    Anteprima al passaggio del mouse
  </label>
);
